
import * as types from "../constants/action-types";

export default function collarReducer(state = [], action) {
    
    switch (action.type) {
        
      
        case types.LOAD_COLLAR_SUCCESS:
            return action.collars;
        default:
            return state;
    };
};


